import { Injectable } from '@angular/core';
import { LoginStorage } from '../../login/login.storage';
import { OMNI_MAIS_REDIRECT_BASE_URL } from '../../../environments/environment';
import { ParametrosNovaFichaSelecionados } from './parametros-nova-ficha-selecionados.interface';
import { ElegibilidadeNovoOmniInput } from './elegibilidade-novo-omni-input.interface';
import { TipoProdutoEnum } from '../../ficha/cadastro/inicio/tipo-operacao/enum/tipo-produto.enum';
import { TipoVeiculoEnum } from '../../produtos/shared/enums/tipo-veiculo.enum';

@Injectable()
export class NovoOmniRedirectService {
  constructor(private loginStorage: LoginStorage) {}

  tentarAbrirNovoOmni(
    input: ElegibilidadeNovoOmniInput,
    redirectPath?: string,
  ): boolean {
    const selecao = this.avaliarSelecao(input);

    if (!selecao) {
      return false;
    }

    this.abrirNovoOmni(selecao, redirectPath);
    return true;
  }

  abrirNovoOmni(
    selectedValues: ParametrosNovaFichaSelecionados,
    redirectPath: string = '/app/rodas/visao-geral',
  ): void {
    const url = this.montarUrlRedirect(selectedValues, redirectPath);
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
    }
  }

  private avaliarSelecao(
    input: ElegibilidadeNovoOmniInput,
  ): ParametrosNovaFichaSelecionados | null {
    const isPessoaFisicaSelected = input.tipoCliente === 'PF';
    const isOperationSelected = [
      TipoProdutoEnum.FINANCIMENTO,
      TipoProdutoEnum.REFINANCIAMENTO,
    ].includes(input.tipoProduto);
    const isProdutoSelecionado = [
      TipoVeiculoEnum.AUTOMOVEIS,
      TipoVeiculoEnum.MOTOCICLETAS,
      TipoVeiculoEnum.PESADOS,
    ].includes(input.tipoVeiculo);
    const isSolicitanteSelecionado = Boolean(input.solicitante);

    const isExpectedSelection =
      isPessoaFisicaSelected &&
      isOperationSelected &&
      isProdutoSelecionado &&
      isSolicitanteSelecionado;

    if (!isExpectedSelection) {
      return null;
    }

    if (input.isPesadosBrasilUser || input.isLeadUser) {
      return null;
    }

    const isPesadosRefinanciamento =
      input.tipoVeiculo === TipoVeiculoEnum.PESADOS &&
      input.tipoProduto === TipoProdutoEnum.REFINANCIAMENTO;

    if (isPesadosRefinanciamento) {
      return null;
    }

    return {
      tipoCliente: input.tipoCliente,
      tipoOperacao: input.tipoProduto,
      produto: input.tipoVeiculo,
      solicitante: input.solicitante,
    };
  }

  private montarUrlRedirect(
    selectedValues: ParametrosNovaFichaSelecionados,
    redirectPath: string,
  ): string {
    const login = this.encodeBase64(this.loginStorage.usuario.login);
    const token = this.encodeBase64(this.loginStorage.usuario.token);
    const agent = this.encodeBase64(
      JSON.stringify(this.loginStorage.agente ?? {}),
    );
    const redirectUrl = this.encodeBase64(redirectPath);

    const queryParams = new URLSearchParams({
      redirectUrl,
      tipoCliente: selectedValues.tipoCliente,
      tipoOperacao: selectedValues.tipoOperacao,
      produto: selectedValues.produto,
      solicitante: selectedValues.solicitante,
    }).toString();

    return `${OMNI_MAIS_REDIRECT_BASE_URL}/auth-redirect/${login}/${token}/${agent}?${queryParams}`;
  }

  private encodeBase64(value: string): string {
    return encodeURIComponent(btoa(value));
  }
}
